import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const checkboxStyle = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  appearance: 'none',
  margin: 0,
  width: '1.15em',
  height: '1.15em',
  minWidth: '1.15em',
  borderRadius: 2,
  border: `1px solid ${vars.color.dark}`,
  background: 'transparent',
  transition: '.2s all ease-in-out',
  cursor: 'pointer',

  selectors: {
    '&:focus': {
      borderColor: vars.color.dark
    },
    '&::before': {
      content: '',
      width: '0.65em',
      height: '0.65em',
      clipPath: 'polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%)',
      transform: 'scale(0)',
      transition: '120ms transform ease-in-out',
      borderRadius: 10,
      background: vars.color.white
    },
    '&:hover': {
      background: vars.color.darkLighter
    },
    '&:checked': {
      background: vars.color.dark,
      borderColor: vars.color.dark
    },
    '&:checked::before': {
      transform: 'scale(1)'
    },
    '&:disabled': {
      background: vars.color.drawBackgroundLighter,
      cursor: 'not-allowed'
    },
    '&:disabled:checked::before': {
      background: vars.color.dark
    }
  }
})

export const checkboxStyleSecondary = style({
  borderColor: vars.color.mediumLighter,
  selectors: {
    '&:hover': {
      background: vars.color.mediumLighter
    },
    '&:checked': {
      background: vars.color.dark,
      borderColor: vars.color.dark
    },
    '&::before': {
      background: vars.color.medium
    }
  }
})

export const checkboxStyleMedium = style({
  borderColor: vars.color.medium,
  selectors: {
    '&:hover': {
      background: vars.color.medium
    },
    '&:checked': {
      background: vars.color.dark,
      borderColor: vars.color.dark
    },
    '&::before': {
      background: vars.color.mediumLighter
    }
  }
})

export const checkBoxLabel = style({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  color: vars.color.dark,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  width: '100%', // Override v2 legacy style
  textAlign: 'left', // Override v2 legacy style
  height: 'auto', // Override v2 legacy style
  float: 'none', // Override v2 legacy style
  padding: 0, // Override v2 legacy style
  margin: 0 // Override v2 legacy style
})
